import { apiSlice } from '../apiSlice';
import { MESSAGES } from './liveChatSystemMessagesMessages';
import { ACTIVITY_TYPES, CHAPTERSOURCE_SCHEMAS } from '../../constants/main';
import { API_TAGS } from '../../constants/api';

export const liveChatMessagesSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    fetchLiveChatSystemMessages: build.query({
      query: ({ orgId, tenantId, urlParams = {} }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities`,
        method: 'GET',
        params: {
          ...urlParams,
          schema: CHAPTERSOURCE_SCHEMAS.FLOWGRAPH,
          types: `${ACTIVITY_TYPES.LIVECHAT_SYSTEM_MESSAGE}`
        },
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.FETCH_LIVE_CHAT_SYSTEM_MESSAGES.ERROR
        }
      }),
      providesTags: (result, error, args) => {
        return [
          { type: API_TAGS.LIVE_CHAT_SYSTEM_MESSAGES, id: 'LIST' }
        ];
      }
    }),

    updateLiveChatSystemMessage: build.mutation({
      query: ({ orgId, tenantId, liveChatSystemMessageId, data, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/${liveChatSystemMessageId}`,
        method: 'PATCH',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_LIVE_CHAT_SYSTEM_MESSAGE.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.UPDATE_LIVE_CHAT_SYSTEM_MESSAGE.SUCCESS
        }
      }),
      transformResponse: (response) => true,
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.LIVE_CHAT_SYSTEM_MESSAGES, id: 'LIST' },
          { type: API_TAGS.BOTS, id: args.tenantId },
          { type: API_TAGS.CHAPTER_SOURCES, id: 'LIST' }
        ];
      }
    }),

    updateLiveChatSystemMessages: build.mutation({
      query: ({ orgId, tenantId, data, successMessage = { showMessage: true } }) => ({
        url: `organizations/${orgId}/tenants/${tenantId}/activities/batch`,
        method: 'PUT',
        body: data,
        errorMessage: {
          showMessage: true,
          messages: MESSAGES.UPDATE_LIVE_CHAT_SYSTEM_MESSAGES.ERROR
        },
        successMessage: {
          ...successMessage,
          messages: MESSAGES.UPDATE_LIVE_CHAT_SYSTEM_MESSAGES.SUCCESS
        }
      }),
      transformResponse: (response) => true,
      invalidatesTags: (result, error, args) => {
        if (error) {
          return [];
        }
        return [
          { type: API_TAGS.LIVE_CHAT_SYSTEM_MESSAGES, id: 'LIST' },
          { type: API_TAGS.BOTS, id: args.tenantId },
          { type: API_TAGS.CHAPTER_SOURCES, id: 'LIST' }
        ];
      }
    })
  })
});

export const {
  useFetchLiveChatSystemMessagesQuery,
  useUpdateLiveChatSystemMessageMutation,
  useUpdateLiveChatSystemMessagesMutation
} = liveChatMessagesSlice;
